<template>
  <div id="customer-list">
    <div class="add-btn-box">
      <el-button type="primary" @click="addProduct">新增产品</el-button>
    </div>
    <div
      class="alarm-table"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table :data="tableList" style="width: 100%">
        <el-table-column prop="name" label="产品名称" align="center">
        </el-table-column>
        <el-table-column prop="code" label="代码" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="joined" label="是否接入平台" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="240">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      :current-page="pagination.currentPage"
      layout="prev, pager, next"
      :total="pagination.total"
      @current-change="pageChange"
    >
    </el-pagination>
    <!-- 弹窗新增编辑 -->
    <base-dialog
      :title='dialogTitle'
      size="small"
      v-if="dialogTableVisibles"
      :visible.sync="dialogTableVisibles"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="110px"
        class="custom-ruleForm"
      >
        <el-form-item
          label="产品名称"
          prop="name"
          :rules="{
            required: true,
            message: '产品名称不能为空',
            trigger: 'blur',
          }"
        >
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item
          label="代码"
          prop="code"
          :rules="{ required: true, message: '代码不能为空', trigger: 'blur' }"
        >
          <el-input v-model="ruleForm.code"></el-input>
        </el-form-item>
        <el-form-item
          label="说明文档地址"
          prop="remarkPath"
          :rules="{
            required: true,
            message: '说明文档地址不能为空',
            trigger: 'blur',
          }"
        >
          <el-input v-model="ruleForm.remarkPath"></el-input>
        </el-form-item>
        <el-form-item label="是否接入平台">
          <el-switch v-model="ruleForm.joined"></el-switch>
        </el-form-item>
        <el-form-item
          label="简介"
          prop="remark"
          :rules="{
            required: true,
            message: '简介不能为空',
            trigger: 'blur',
          }"
        >
          <el-input type="textarea" v-model="ruleForm.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '@/components/BaseDialog.vue'
import { formatTime } from '@/utils/objectUtil.js'
import {
  getProductslist,
  deleteProducts,
  saveProduct,
  getlistDictByType,
  productDetail,
  updateProduct,
} from './service'
export default {
  name: 'CustomerList',
  components: {
    BaseDialog,
  },
  data () {
    return {
      dialogTitle: '',
      dialogTableVisibles: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dialogState: 'add',
      loading: false,
      tableList: [],
      productId: '', // 当前产品id
      areaList: [],
      ruleForm: {
        name: '',
        code: '',
        remarkPath: '',
        joined: false,
        remark: '',
      },
    }
  },
  computed: {},
  mounted () {
    // 获取产品列表
    this.getProducts()
    // 获取区域列表
    this.getlistDictType()
  },
  methods: {
    // 编辑产品
    handleEdit (index, row) {
      this.productId = row.id
      this.getproductDetail(row.id)
      this.dialogState = 'edit'
      this.dialogTitle = '编辑'
    },
    // 删除产品
    handleDelete (index, row) {
      debugger
      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await deleteProducts(row.id)
          if (res.code === 0) {
            this.$message.success({ message: '操作成功', duration: 1500 })
            this.pagination.currentPage = 1
            this.getProducts()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 新建用户弹窗关闭
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.ruleForm.joined = false
      this.ruleForm.name = ''
      this.ruleForm.code = ''
      this.ruleForm.remarkPath = ''
      this.ruleForm.remark = ''
      this.dialogTableVisibles = false
    },
    // 新增产品事件
    addProduct () {
      this.dialogState = 'add'
      this.dialogTableVisibles = true
      // this.resetForm('ruleForm')
      this.dialogTitle = '新增'
    },
    /**
     * @description:   分页改变事件
     * @param {Number} currPage  当前页码
     * @return {*}
     */
    pageChange (currPage) {
      this.pagination.currentPage = currPage
      this.getProducts()
    },
    // 获取产品详情
    async getproductDetail (id) {
      const res = await productDetail(id)
      this.dialogTableVisibles = true
      console.log(res)
      this.ruleForm = res.data
      console.log(this.ruleForm)
    },
    // 获取产品列表分页
    async getProducts () {
      const params = {
        pageNo: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }
      const res = await getProductslist(params)
      let lists = res.data.list.map(val => {
        val.createTime = formatTime(new Date(val.createTime))
        val.joined = val.joined ? '是' : '否'
        return val
      })
      console.log(lists)
      this.tableList = lists
      this.pagination.total = Number(res.data.total)
    },
    // 获取大区列表
    async getlistDictType () {
      const params = {
        type: 1,
      }
      const res = await getlistDictByType(params)
      this.areaList = res.data
    },
    // 新建产品
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogState === 'add') {
            this.savePro()
          } else {
            this.updatePro()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 保存产品信息
    async savePro () {
      const params = {
        name: this.ruleForm.name,
        code: this.ruleForm.code,
        remarkPath: this.ruleForm.remarkPath,
        joined: this.ruleForm.joined,
        remark: this.ruleForm.remark,
      }
      const res = await saveProduct(params)
      if (res.code === 0) {
        this.$message.success({ message: '操作成功', duration: 1000 })
        this.dialogTableVisibles = false
        this.getProducts()
        this.resetForm()
      } else {
        this.$message.error({ message: res.msg })
        // this.dialogTableVisibles = false
      }
    },
    // 更新产品信息
    async updatePro () {
      const params = {
        name: this.ruleForm.name,
        code: this.ruleForm.code,
        remarkPath: this.ruleForm.remarkPath,
        joined: this.ruleForm.joined,
        remark: this.ruleForm.remark,
        id: this.productId,
      }
      const res = await updateProduct(params)
      if (res.code === 0) {
        this.$message.success({ message: '操作成功', duration: 1000 })
        this.dialogTableVisibles = false
        this.getProducts()
        this.resetForm()
      } else {
        this.$message.error({ message: res.msg })
        // this.dialogTableVisibles = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
#customer-list {
  position: relative;
  .alarm-table {
    margin-top: 60px;
  }
  .add-btn-box {
    position: absolute;
    right: 60px;
    top: -38px;
    z-index: 1;
  }
  .custom-ruleForm {
    margin: 30px;
  }
}
</style>
